import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3c5092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-pages" }
const _hoisted_2 = { class: "center-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import TopLogin from "@/views/Login/_components/TopLogo/inde.vue";
import CenterInput from "@/views/Login/_components/CenterInput/index.vue";
import { reactive } from "vue";

/** 图片 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const icons = reactive({
  img_login_left_top: require("./_static/img_login_left_top.png"),
  img_login_right_bottom: require("./_static/img_login_right_bottom.png")
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopLogin),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CenterInput)
    ]),
    _createElementVNode("img", {
      class: "img-left-top",
      src: icons.img_login_left_top,
      alt: ""
    }, null, 8, _hoisted_3),
    _createElementVNode("img", {
      class: "img_right_bottom",
      src: icons.img_login_right_bottom,
      alt: ""
    }, null, 8, _hoisted_4)
  ]))
}
}

})